import { useId } from "react";
import { formatINR } from "@/lib/lamka";

export const VelvetHanger = ({ price }) => {
  const u = useId().replace(/:/g, "");
  return (
  <div className="relative h-[66px] w-full pointer-events-none" aria-hidden="true">
    <svg viewBox="0 0 170 66" className="absolute inset-0 h-full w-full overflow-visible">
      <defs>
        <linearGradient id={`vh-gold-${u}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#F6E3A8" />
          <stop offset="0.5" stopColor="#C9A24E" />
          <stop offset="1" stopColor="#8A6A26" />
        </linearGradient>
        <linearGradient id={`vh-velvet-${u}`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#3A3A3A" />
          <stop offset="0.45" stopColor="#1A1A1A" />
          <stop offset="1" stopColor="#050505" />
        </linearGradient>
        <filter id={`vh-shadow-${u}`} x="-20%" y="-20%" width="140%" height="180%">
          <feDropShadow dx="0" dy="3" stdDeviation="2.2" floodColor="#2B1D0E" floodOpacity="0.35" />
        </filter>
      </defs>
      <path d="M85 30 V20 C85 15 89 13 91.5 11 C95 8.5 94.5 3 90 1.6 C86 0.4 82 3 82 6.5" fill="none" stroke={`url(#vh-gold-${u})`} strokeWidth="2.4" strokeLinecap="round" />
      <g filter={`url(#vh-shadow-${u})`}>
        <rect x="80.5" y="28" width="9" height="7" rx="2" fill={`url(#vh-gold-${u})`} />
        <path d="M85 33 C64 38 34 47 14 54 C8 56 7 61 12 62 L26 62 C46 56 66 50 85 47 C104 50 124 56 144 62 L158 62 C163 61 162 56 156 54 C136 47 106 38 85 33 Z" fill={`url(#vh-velvet-${u})`} />
        <path d="M85 35 C66 40 38 48 18 55" stroke="#5A5A5A" strokeOpacity="0.55" strokeWidth="0.8" fill="none" />
        <path d="M85 35 C104 40 132 48 152 55" stroke="#5A5A5A" strokeOpacity="0.55" strokeWidth="0.8" fill="none" />
      </g>
    </svg>
    <div className="absolute left-1/2 top-[30px] ml-[8px] origin-top-left -rotate-[14deg]">
      <span className="block h-[10px] w-px bg-[#8A6A26]/70 ml-[3px]" />
      <span data-testid="thrift-hook-price-tag" className="block rounded-[3px] bg-[#FBF7EF] px-1.5 py-[2px] font-mono text-[9px] font-semibold text-[#0F0F0F] shadow-[0_2px_4px_rgba(43,29,14,0.35)] whitespace-nowrap">
        {formatINR(price)}
      </span>
    </div>
  </div>

  );
};
